export const GAMES = [
{
        id: 10,
        name: "Match Master",
        src: "images/Match-Master.png",
        alt: "screenshot of match master game",
        desc: "Match Master was originally created using UnityScript but has been converted to C# in Unity Game Engine",
        link: "https://games.johngilday.com/Match-Master",
        btnTxt: "Play the Game"
    },
    {
        id: 11,
        name: "Asteroid Blaster",
        src: "images/Asteroid-Blaster.png",
        alt: "screenshot of asteroid blaster game",
        desc: "Asteroid Blaster was originally created using UnityScript but has been converted to C# in Unity Game Engine",
        link: "https://games.johngilday.com/Asteroid-Blaster",
        btnTxt: "Play the Game"
    }
]